import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-header-page-spdji',
  templateUrl: './header-page-spdji.component.html',
  styleUrls: ['./header-page-spdji.component.scss']
})
export class HeaderPageSpdjiComponent implements OnInit {

  searchOpened = false;
  searchTerm = '';
  openSiteLinkDropdown = false;
  openLangDropdown = false;
  openAboutDropdown = false;
  openedNavList = '';
  constructor() { }

  ngOnInit(): void {
  }

  openNavList(event: any, option: string): void{
    this.openedNavList = this.openedNavList === option ? '' : option;
    event.preventDefault();
  }

  runSearch(event: any): void{
    if (event.type === 'click' || event.key === 'Enter') {
      window.location.href = 'https://www.spglobal.com/spdji/en/search/?query=' + this.searchTerm;
      }
  }

  toggleDropdowns(menu: string): void{
    this.openSiteLinkDropdown = menu === 'openSiteLinkDropdown' && !this.openSiteLinkDropdown;
    this.openLangDropdown = menu === 'openLangDropdown' && !this.openLangDropdown;
    this.openAboutDropdown = menu === 'openAboutDropdown' && !this.openAboutDropdown;
  }

}
